import { to } from 'acl';
import { SitePermission } from 'apollo/generated/client-operations';
import type { AuthUser } from 'auth/types';
import type { SitePermissions } from 'sitePermissions/useSitePermissions';

/** Which sections of the Site Layout tab a user sees at a site. */
export type SiteLayoutSections = {
  /** The geofencing form, the only thing the tab's Save Changes submits. */
  geofencing: boolean;
  /** The layout versions list, and the designer its rows open. */
  versions: boolean;
};

/**
 * The Site Layout tab's sections while the site's `site-layout-ui-enabled`
 * flag is on, each behind its own gate, so opening the tab exposes no
 * setting or write the user does not already hold:
 * - geofencing and its Save Changes keep the legacy
 *   `editJobsiteConfiguration`, as every legacy settings tab does;
 * - the versions list and the designer need View site layout from the site
 *   permission catalog, and the designer's actions Manage site layout.
 * A user with only one of them sees only that section; the tab shows when
 * either passes. While the catalog loads, the versions wait.
 */
export const siteLayoutSections = ({
  siteLayoutUiEnabled,
  jobsiteId,
  user,
  sitePermissions,
}: {
  siteLayoutUiEnabled: boolean;
  jobsiteId: string;
  user: AuthUser;
  sitePermissions: SitePermissions;
}): SiteLayoutSections => ({
  geofencing: user.isAllowed(to.editJobsiteConfiguration, jobsiteId),
  versions:
    siteLayoutUiEnabled &&
    !sitePermissions.loading &&
    sitePermissions.can(SitePermission.ViewSiteLayout),
});
